## 1. Uruchamiamy program MS Excel.

## 2. Na stronie głównej wybieramy opcję "Pusty skoroszyt".
![](https://i.imgur.com/KTe5G8i.png)

## 3. Oto widok jaki powinniśmy zobaczyć.
![](https://i.imgur.com/3OASTDU.png)
